import {
  createApi,
  fetchBaseQuery,
  FetchArgs,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react'
import { notifications } from '@mantine/notifications'
import { BaseQueryFn, FetchBaseQueryError } from '@reduxjs/toolkit/query'

import { RootState } from 'src/Redux'
import { getEnvConfig } from 'src/config/env'

const apiConfig = getEnvConfig()

type ExtendedFetchBaseQueryError = FetchBaseQueryError & {
  originalStatus?: number
}

const baseFetchQuery = fetchBaseQuery({
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).authentication?.credentials
      ?.AccessToken
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }

    return headers
  },
  baseUrl: apiConfig.VITE_API_SERVER,
})

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  object,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const result = await baseFetchQuery(args, api, extraOptions)

  if (
    result.error &&
    (result.error as ExtendedFetchBaseQueryError).originalStatus! >= 500
  ) {
    notifications.show({
      title: 'Ошибка сервера',
      message: 'Что-то пошло не так, обратитесь к администратору',
      color: 'red',
      position: 'top-right',
    })
  }

  return result
}

export const baseApi = createApi({
  baseQuery,
  tagTypes: [
    'transport',
    'clients',
    'offers',
    'tools',
    'contracts',
    'models',
    'settings',
    'modelTypes',
    'documents',
    'users',
  ],
  // Время хранения неиспользуемых данных в кэше (5 минут)
  keepUnusedDataFor: 300,
  // Автоматическое обновление при фокусе окна
  refetchOnFocus: true,
  // Автоматическое обновление при восстановлении соединения
  refetchOnReconnect: true,

  endpoints: () => ({}),
})
